import { compose, mapProps, getContext } from 'core/libs/recompose';
import breakpointPropTypes from 'core/utils/prop-types/breakpoint';
import { MOBILE, DESKTOP } from 'core/components/breakpoint/values';

// TODO: Переписать это на новое context api реакта.
// На данный момент это нельзя реализовать, потому что с этим не работает
// резолвинг данных.
const withBreakpoint = compose(
  getContext({
    initialBreakpoint: breakpointPropTypes(),
  }),
  mapProps(props => {
    const {
      initialBreakpoint,
      ...otherProps
    } = props;

    const breakpoint = props.breakpoint || initialBreakpoint;

    return {
      ...otherProps,
      breakpoint,
      isMobile: breakpoint === MOBILE,
      isDesktop: breakpoint === DESKTOP,
    };
  }),
);

export default withBreakpoint;

// Оставляем withNonPureBreakpoint для обратной совместимости
export const withNonPureBreakpoint = withBreakpoint;
